module.exports = __webpack_public_path__ + "static/media/raaz_img2.8c1b589f.png";